export default __webpack_public_path__ + "static/media/illustration-recruit-6-m@2x.cbc3cd45.webp";